//C:\ViYash\XPRSuvey\XPRSuvey-App\src\Components\HR\HRLayout\Footer.jsx
export default function Footer() {
	return (
		<footer className="bg-white">
			<div className="border-t border-[#c2a8f033] py-1.5 text-center text-[11px] text-gray-600">
				Design and Developed By :-{" "}
				<span className="font-medium text-blue-500">
					VRSamadhan Tech Solution
				</span>
			</div>
		</footer>
	);
}
